export default __webpack_public_path__ + "images/K9.27b6cba.png";